import React from 'react';
import TabContainer from "./TabContainer";
import AllTestTab from "../AllTestTab/AllTestTab";
import TestSeriesList from "../TestSeriesList/TestSeriesList";
import { useAllTestList, useTestSeriesList } from "examsbook-react-sdk/custom-hooks";
import PracticeTab from "../PracticeTab/PracticeTab";

/**
 * All test container.
 * @param props
 * @returns {*}
 * @constructor
 */
function AllDashboardContainer(props) {
    const { selectedIndex, subExamList, handleTabChange } = props;
    const { allTestList } = useAllTestList();
    const { testSeriesList, testSeriesLoading } = useTestSeriesList();
    return (
        <div>
            {selectedIndex === 1 &&
            <TabContainer className="allTest">
                <AllTestTab
                    quizList={allTestList}
                    subExamList={subExamList} ßß
                    handleTabChange={handleTabChange}
                    activeIndex={selectedIndex}
                    testSeriesList={testSeriesList}
                    testSeriesLoading={testSeriesLoading}
                    noDataMessage="No quizzes selected in this exam"/>
            </TabContainer>}
            {selectedIndex === 2 && <TabContainer className="Test-series">
                <TestSeriesList handleTabChange={handleTabChange}
                                testSeriesList={testSeriesList}
                                testSeriesLoading={testSeriesLoading}/>
            </TabContainer>}
            {selectedIndex === 3 && <TabContainer className="practice-tab Test-series">
                <PracticeTab activeIndex={selectedIndex}/>
            </TabContainer>}

        </div>
    );
}

export default AllDashboardContainer;
